"use client";

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { v4 as uuidv4 } from 'uuid';
import { getSubdomain } from '@/lib/subdomain';

export function AnalyticsListener() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    // useRef para evitar disparos duplos em desenvolvimento (React Strict Mode)
    const lastPath = useRef<string | null>(null);

    // Função auxiliar para pegar o Tenant ID (Subdomínio)
    const getTenantId = () => {
        return getSubdomain();
    };

    // Função global de envio (pode ser exportada se precisar usar fora daqui)
    const trackEvent = async (eventType: string, payload: any = {}) => {
        try {
            // Gerenciamento de Sessão (reseta se fechar o navegador)
            let sessionId = sessionStorage.getItem('aesir_analytics_session');
            if (!sessionId) {
                sessionId = uuidv4();
                sessionStorage.setItem('aesir_analytics_session', sessionId);
            }

            const eventData = {
                tenant_id: getTenantId(),
                session_id: sessionId,
                event_type: eventType,
                page_url: window.location.href,
                payload: payload
            };

            // Envia para nossa rota interna do Next.js
            await fetch('/api/analytics', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(eventData),
                keepalive: true // Garante o envio mesmo se a pessoa fechar a aba rápido
            });

        } catch (err) {
            // Falha silenciosa
            console.warn("[Analytics] Erro interno:", err);
        }
    };

    // Monitora Mudança de Rota (Page View)
    useEffect(() => {
        const currentPath = `${pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
        
        // Evita disparos repetidos na mesma renderização
        if (lastPath.current === currentPath) return;
        lastPath.current = currentPath;

        let eventType = 'page_view';
        let payload: any = {};

        // Detecta tipos específicos de página
        if (pathname.startsWith('/produtos/')) {
            eventType = 'view_product';
            payload.product_id = pathname.split('/').pop();
        } else if (pathname === '/buscar' && searchParams.get('search')) {
            eventType = 'search';
            payload.search_term = searchParams.get('search');
        }

        trackEvent(eventType, payload);

    }, [pathname, searchParams]);

    return null;
}

// Exporta a função auxiliar para usar no CartContext também
export const sendAnalyticsEvent = async (eventType: string, payload: any = {}) => {
    // Replicamos a lógica simples aqui para ser usada fora do componente React
    try {
        let sessionId = sessionStorage.getItem('aesir_analytics_session');
        if (!sessionId) { sessionId = uuidv4(); sessionStorage.setItem('aesir_analytics_session', sessionId); }
        
        const tenantId = getSubdomain();

        await fetch('/api/analytics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                tenant_id: tenantId,
                session_id: sessionId,
                event_type: eventType,
                page_url: window.location.href,
                payload: payload
            }),
            keepalive: true
        });
    } catch(e) {}
};